var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsErrorMsj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56225 23.9444L5.57188 23.814H22.6974C23.4306 23.814 24.0947 23.4395 24.4719 22.8121C24.6574 22.5067 24.7598 22.1576 24.7703 21.8006C24.7808 21.4506 24.6994 21.1015 24.5366 20.7909L24.527 20.7743L15.8916 4.47212C15.5145 3.86925 14.8539 3.5 14.1346 3.5C13.3655 3.5 12.6646 3.92175 12.3041 4.60075L3.74313 20.7743C3.57425 21.0901 3.49113 21.4445 3.50075 21.8006C3.51038 22.1567 3.61275 22.5067 3.79825 22.8112C3.982 23.1192 4.24275 23.3739 4.5525 23.5489C4.8605 23.7221 5.20963 23.814 5.56225 23.814V23.9444ZM5.137 22.0062L5.34088 21.6204L14.1346 5.00937L23.1375 22.0062H5.137Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8174 9.85962L13.0674 9.85962L13.0674 15.9846L14.8174 15.9846L14.8174 9.85962Z",
    fill: "#565656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8751 17.4431L13.0674 17.4431L13.0674 19.25L14.8751 19.25L14.8751 17.4431Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsErrorMsj);
export default __webpack_public_path__ + "static/media/icons-error-msj.bd8d79e039780288f9454f1270c2cebd.svg";
export { ForwardRef as ReactComponent };